import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import './AppTokens.css';

function AppTokens() {
  const navigate = useNavigate();
  const [tokens, setTokens] = useState([]);
  const [newToken, setNewToken] = useState(null);
  const [deviceName, setDeviceName] = useState('');
  const [loading, setLoading] = useState(false);
  const [showTokenDialog, setShowTokenDialog] = useState(false);

  useEffect(() => {
    loadTokens();
  }, []);

  const loadTokens = async () => {
    try {
      const response = await api.get('/auth/app-tokens');
      setTokens(response.data);
    } catch (error) {
      console.error('Erreur chargement tokens', error);
    }
  };

  const generateToken = async () => {
    if (!deviceName.trim()) {
      alert('Veuillez entrer un nom d\'appareil');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/auth/generate-app-token', {
        device_name: deviceName
      });

      setNewToken(response.data);
      setShowTokenDialog(true);
      setDeviceName('');
      loadTokens();
    } catch (error) {
      alert('Erreur lors de la génération du token');
    } finally {
      setLoading(false);
    }
  };

  const revokeToken = async (tokenId) => {
    if (!window.confirm('Voulez-vous vraiment révoquer ce token ?')) return;

    try {
      await api.delete(`/auth/app-tokens/${tokenId}`);
      loadTokens();
    } catch (error) {
      alert('Erreur lors de la révocation');
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert('Copié dans le presse-papier !');
  };

  return (
    <div className="app-tokens-container">
      <div className="app-tokens-header">
        <button className="btn-back" onClick={() => navigate('/')}>
          ← Retour
        </button>
        <h1>📱 Tokens d'Application Mobile</h1>
      </div>

      <div className="token-generator">
        <h2>Générer un nouveau token</h2>
        <p className="info-text">
          Créez un token permanent pour connecter votre application mobile à la galerie.
        </p>

        <div className="generator-form">
          <input
            type="text"
            placeholder="Nom de l'appareil (ex: iPhone 14, Samsung Galaxy)"
            value={deviceName}
            onChange={(e) => setDeviceName(e.target.value)}
            className="device-input"
          />
          <button 
            onClick={generateToken} 
            disabled={loading}
            className="btn-generate"
          >
            {loading ? 'Génération...' : '🔑 Générer Token'}
          </button>
        </div>
      </div>

      {tokens.length > 0 && (
        <div className="tokens-list">
          <h2>Tokens actifs</h2>
          {tokens.map(token => (
            <div key={token.id} className="token-card">
              <div className="token-info">
                <h3>📱 {token.device_name}</h3>
                <p className="token-date">
                  Créé le {new Date(token.created_at).toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              </div>
              <button 
                onClick={() => revokeToken(token.id)}
                className="btn-revoke"
              >
                ✕ Révoquer
              </button>
            </div>
          ))}
        </div>
      )}

      {showTokenDialog && newToken && (
        <div className="token-dialog-overlay" onClick={() => setShowTokenDialog(false)}>
          <div className="token-dialog" onClick={(e) => e.stopPropagation()}>
            <h2>✅ Token généré avec succès</h2>
            
            <div className="config-section">
              <h3>📡 Configuration de l'application</h3>
              
              <div className="config-item">
                <label>URL de l'API :</label>
                <div className="copy-box">
                  <code>{newToken.api_url}</code>
                  <button onClick={() => copyToClipboard(newToken.api_url)}>
                    📋 Copier
                  </button>
                </div>
              </div>

              <div className="config-item">
                <label>Token d'authentification :</label>
                <div className="copy-box">
                  <code className="token-value">{newToken.token}</code>
                  <button onClick={() => copyToClipboard(newToken.token)}>
                    📋 Copier
                  </button>
                </div>
              </div>

              <div className="config-item">
                <label>Appareil :</label>
                <p>{newToken.device_name}</p>
              </div>

              <div className="config-item">
                <label>Validité :</label>
                <p>{newToken.expires_in}</p>
              </div>
            </div>

            <div className="instructions">
              <h3>📱 Instructions</h3>
              <ol>
                <li>Ouvrez votre application mobile de synchronisation</li>
                <li>Collez l'<strong>URL de l'API</strong> dans le champ correspondant</li>
                <li>Collez le <strong>Token</strong> dans le champ d'authentification</li>
                <li>Sélectionnez l'album de destination (ou créez-en un)</li>
                <li>Activez la synchronisation automatique</li>
              </ol>
            </div>

            <div className="warning-box">
              <p>⚠️ <strong>Important :</strong> Conservez ce token en sécurité. Il donne accès à votre compte pendant 1 an.</p>
              <p>💡 Vous pouvez révoquer ce token à tout moment depuis cette page.</p>
            </div>

            <button 
              className="btn-close-dialog" 
              onClick={() => setShowTokenDialog(false)}
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AppTokens;